import { LOAD_DATA, LOAD_IMAGES } from "./actions";

const initialState = {
  data: [],
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA:
      return {
        ...state,
        data: action.payload, // Update the data with the loaded static JSON
      };
    case LOAD_IMAGES:
      return {
        ...state,
        images: action.payload, 
      };
    default:
      return state;
  }
};

export default dataReducer;
